import { useEffect, useState } from 'react';

/**
 * Dải cảnh báo "BẢN THỬ".
 *
 * Người dùng không có cách nào nhìn màn hình mà biết mình đang ở bản thật hay
 * bản thử — hai bản giống hệt nhau, chỉ khác tên miền, mà tên miền thì không ai
 * để ý sau khi đã mở tab. Gõ một lệnh ngân sách nhầm bản là chuyện rất dễ xảy
 * ra, nên phải nói thẳng ra trên màn hình.
 *
 * Đọc `/health` — đường dẫn công khai, không cần đăng nhập — nên dải này hiện
 * ngay từ màn đăng nhập, là lúc dễ nhầm nhất.
 */
interface TinhTrang {
  moiTruong?: 'that' | 'thu';
  ghiNenTang?: boolean;
}

export function DaiBanThu() {
  const [tt, datTt] = useState<TinhTrang | null>(null);

  useEffect(() => {
    let con = true;
    fetch('/health')
      .then((r) => r.json())
      .then((d) => {
        if (con) datTt(d as TinhTrang);
      })
      // Không đọc được thì im lặng: dải này là lớp nhắc, không phải chức năng
      // chính, hỏng nó không được phép chặn người dùng đăng nhập.
      .catch(() => {});
    return () => {
      con = false;
    };
  }, []);

  if (tt?.moiTruong !== 'thu') return null;

  // Bản thử mà VẪN cho ghi ra nền tảng là trạng thái nguy hiểm nhất: nhìn thì
  // giống bản thử, nhưng lệnh đi ra ngoài thật. Phải cảnh báo mạnh hơn.
  const choGhi = tt.ghiNenTang === true;
  const mau = choGhi ? '#b91c1c' : '#b45309';
  const chu = choGhi
    ? 'BẢN THỬ — ĐANG ĐƯỢC PHÉP GHI RA NỀN TẢNG THẬT'
    : 'BẢN THỬ — dữ liệu ở đây không phải dữ liệu thật';

  return (
    <>
      <div
        aria-hidden
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          background: mau,
          zIndex: 9999,
        }}
      />
      <div
        role="status"
        style={{
          position: 'fixed',
          top: 8,
          left: 8,
          zIndex: 9999,
          background: mau,
          color: '#fff',
          font: '600 11px/1.3 system-ui, sans-serif',
          letterSpacing: .2,
          padding: '4px 10px',
          borderRadius: 999,
          // Mờ để không đè hẳn lên logo ở góc trái, nhưng vẫn đủ rõ để nhìn
          // phát là biết mình đang ở bản nào. BOSS chọn vị trí này 19/09/2026.
          opacity: .8,
          maxWidth: 'calc(100vw - 24px)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          // Chuột xuyên qua. Đây chỉ là nhãn nhắc, không phải nút bấm, nên dù nó
          // nằm đè lên cái gì thì cái đó vẫn bấm được.
          pointerEvents: 'none',
        }}
      >
        {chu}
      </div>
    </>
  );
}
